import { Checkbox, CheckboxProps } from '@components/checkbox';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormCheckboxProps<T = unknown> = FormFieldProps<CheckboxProps, T>;

export function FormCheckbox<T>(props: FormCheckboxProps<T>) {
  const formFieldProps = useFormField(props);

  return <Checkbox {...props} {...formFieldProps} />;
}
